const ItemTypes = {
  LEGION: 'legion'
};

export default ItemTypes;
